import React from "react";
import InfoCard from "./infoCard";

const Info = () => {
  return (
    <div className="about__info grid">
      <InfoCard
        icon="bx bx-award"
        title="Experience"
        subtitle="1 Years Working"
      />
      <InfoCard
        icon="bx bx-briefcase-alt"
        title="Completed"
        subtitle="20+ Projects"
      />
      <InfoCard icon="bx bx-support" title="Support" subtitle="Online 24/7" />
    </div>
  );
};

export default Info;
